import React, {useEffect} from 'react';
import {ReactComponent as ArrayLeftIcon} from '../../../../../assets/main/groups/main-table/array-left.svg';
import {MainTop} from "../../../groups/group-container/main-top/Main-top";
import AuthWrapper from "../../../../auth-wrapper/AuthWrapper";
import {TestCreateItem} from "./test-create-item/TestCreateItem";
import {useParams} from "react-router-dom";
import {useAppDispatch} from "common/hook";
import {fetchTest} from "features/model/service/test/get-test/fetchTest";

export const TestEdit = () => {
    const dispatch = useAppDispatch()
    const {testId} = useParams();


    useEffect(() => {
        dispatch(fetchTest(testId));
    }, [dispatch, testId]);



    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Редактировать тест'} tabs={false} setting={false} link={'/test/add-test'}
                         icons={<ArrayLeftIcon/>}/>
                <TestCreateItem/>
            </div>
        </AuthWrapper>
    );
};

